// The admin pages do NOT scroll the window. Paper Dashboard puts the content inside
// #mainPanel (AdminLayout), which PerfectScrollbar manages with overflow-y: hidden - so
// neither window.scrollY nor a DataGrid's own virtual scroller is the thing that moves.
// Assigning scrollTop on it programmatically still works despite the hidden overflow.
//
// Containers that swap a list out for a detail view need this to put the list back where it
// was, and getting the element wrong is easy, so it lives in one place.

const PANEL_ID = 'mainPanel'

const getPanel = () => document.getElementById(PANEL_ID)

export const getPanelScrollTop = () => {
  const panel = getPanel()
  if (panel) return panel.scrollTop
  // Fallback for layouts without the panel, e.g. if this is ever used outside AdminLayout.
  return document.scrollingElement ? document.scrollingElement.scrollTop : 0
}

export const setPanelScrollTop = (top) => {
  if (typeof top !== 'number' || isNaN(top)) return
  const panel = getPanel()
  if (panel) {
    panel.scrollTop = top
    return
  }
  if (document.scrollingElement) document.scrollingElement.scrollTop = top
}

// Retry schedule in ms after the immediate attempt. A single assignment is not enough: a
// DataGrid that has just mounted has not measured its rows yet, so the panel is still short
// and the browser CLAMPS the offset. Measured on the activities list - restoring 1400 into a
// freshly mounted grid landed at 59, because the panel was ~1309px tall at that instant and
// only grew to 2977px once the rows were laid out.
const RETRIES = [0, 50, 120, 250, 450, 700, 1000]

let activeRestore = 0

// Puts the panel back to `top`, retrying while the content is still growing. Stops early once
// the offset sticks, or once the content is provably too short to reach it (then it settles at
// the bottom, which is the honest answer). A later call supersedes an earlier one.
export const restorePanelScroll = (top) => {
  if (typeof top !== 'number' || isNaN(top) || top <= 0) return
  const token = ++activeRestore

  const attempt = () => {
    if (token !== activeRestore) return true // superseded, stop
    const panel = getPanel()
    if (!panel) {
      setPanelScrollTop(top)
      return true
    }
    panel.scrollTop = top
    const reachable = panel.scrollHeight - panel.clientHeight
    if (Math.abs(panel.scrollTop - top) <= 2) return true // stuck, we are done
    if (reachable <= top && Math.abs(panel.scrollTop - reachable) <= 2) {
      // Content genuinely cannot scroll that far - the list is shorter than it was. Leave it
      // at the bottom rather than fighting, but keep trying in case rows are still arriving.
      return false
    }
    return false
  }

  if (attempt()) return
  RETRIES.forEach((delay) => setTimeout(attempt, delay))
}
